import { Theme } from '@mui/system';
import {
	descriptionDpCardCategorySX,
	titleDpCardCategorySX,
} from '@/components/blocks/DpLibrary/DpCardCategory/styles/typography';
import { Img } from '@/components/blocks/MaterialImage';
import { Grid, Typography } from '@mui/material';
import { Linkable } from '@/components/blocks/Linkable';

export const DpCardCategory = ({
	title,
	description,
	image,
	href,
	loading,
	priority,
}: {
	title: string;
	description: string;
	image: string;
	href?: string;
	loading?: 'lazy' | 'eager';
	priority?: boolean;
}) => (
	<Linkable href={href}>
		<Grid>
			<Img
				src={image}
				sx={(theme: Theme) => ({
					objectFit: 'cover',
					width: '309px',
					height: '362px',
					[theme.breakpoints.down('sm')]: {
						width: '100%',
						height: '180px',
					},
				})}
				loading={loading}
				priority={priority}
			/>
			<Typography sx={{ ...titleDpCardCategorySX }}>{title}</Typography>
			<Typography sx={{ ...descriptionDpCardCategorySX }}>{description}</Typography>
		</Grid>
	</Linkable>
);
